<template>
  <button
    :class="sm ? 'px-3 py-1 text-sm font-normal' : 'px-6 py-2 font-bold'"
    :disabled="disabled"
    class="button-border-radius neutral-background-3 outline-none secondary-button-text body-font cta-button-case"
    @click.prevent="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "SecondaryButton",
  props: {
    disabled: Boolean,
    sm: Boolean
  }
};
</script>

<style scoped>
button:active {
  @apply bg-opacity-75;
  background-color: var(--neutral-background-3);
}

button:focus {
  outline: none;
}

button:disabled {
  background-color: var(--primary-background-disabled);
}
</style>
